import { ReportScreenTabTypes } from '../../pages/reports/ProjectOverview';
import ProcessingSummaryAndExceptionsDetails from './ProcessingSummaryAndExceptionsDetails';
import ProcessingSummaryAndExceptionsHeader from './ProcessingSummaryAndExceptionsHeader';

interface Props {
  openSpecificTab?: (type: ReportScreenTabTypes) => void;
  canViewSummary: boolean;
  canViewExceptions: boolean;
}

const ProcessingSummaryAndExceptions: React.FC<Props> = ({openSpecificTab, canViewExceptions, canViewSummary}) => {
  return (
    <>
      <ProcessingSummaryAndExceptionsHeader />
      <ProcessingSummaryAndExceptionsDetails 
        openSpecificTab={openSpecificTab} 
        canViewExceptions={canViewExceptions} 
        canViewSummary={canViewSummary}
      />
    </>
  );
};

export default ProcessingSummaryAndExceptions;
